<template>
  <transition name="el-zoom-in-bottom">
        <div class="advertising_board" v-show="boardDisplayed" @click="toLink">
          <!-- <div class="advertising_board__inner"> -->
        <!-- <div class="close"><i class="el-icon-close advertising_board__close_icon" @click="handleCloseBoard" /></div> -->
        <img v-if="!!banner.image"  :src="banner.image" alt="" class="advertising_img" >
        <!-- <img src="@/assets/image/advertising_board.png" class="advertising_board__img" alt=""> -->
        <!-- <div class="advertising_board__slogan"> -->
<!--          <strong><span class="download_text">下载</span> <span class="app_name">超级简历APP</span></strong>-->
<!--          <span>写简历、找工作、看面经</span>-->
<!--          <span>名企精英都在用的简历制作神器</span>-->
          <!-- <strong><span class="download_text">超级简历内推好工作</span></strong>
          <span>从简历直达Offer，快人一步拿高薪</span>
        </div> -->
        <!-- <div class="advertising_board__qr_code"> -->
<!--          <img src="https://files.wondercv.com/download-code/job-community.png" class="qrcode_img" alt="">-->
          <!-- <img src="https://files.wondercv.com/pc/code/bbsBottomNew.png" class="qrcode_img" alt="">
          <div class="qr_code_text">加入高薪求职情报交流群</div> -->
        <!-- </div> -->
      <!-- </div> -->
    </div>
  </transition>
</template>

<script>
// 页面广告牌
import api from '~/api'
import { getBannerParams } from '@/assets/js/util';

function getScrollTop() {
  let scrollPos = null
  if (window.pageYOffset) {
    scrollPos = window.pageYOffset
  }  else if (document.compatMode && document.compatMode != 'BackCompat')  {
    scrollPos = document.documentElement.scrollTop
  } else if (document.body) {
    scrollPos = document.body.scrollTop
  }
  return scrollPos
}

export default {
  name: 'AdvertisingBoard',
  props: {
    displayValue: {
      type: Number,
      default: 500,
      required: false
    }
  },
  data() {
    return {
      boardDisplayed: process.server ? false : getScrollTop() > this.displayValue,
      banner:'',
      resRouter:'',
    }
  },
  mounted() {
    localStorage.removeItem('board-closed')
    window.addEventListener('scroll', this.setBoardDisplayed, false)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('scroll', this.setBoardDisplayed, false)
    })
  },
  created() {
     this.changeRouter();
  },
  methods: {
    handleCloseBoard() {
      this.boardDisplayed = false
      localStorage.setItem('board-closed', '1')
    },
    setBoardDisplayed(e) {
      const boardClosed = localStorage.getItem('board-closed')
      if (boardClosed !== null) return
      const scrollTopValue = getScrollTop()
      this.boardDisplayed = scrollTopValue > this.displayValue
    },
    //获取banner
    async getBanner(e) {
			// banner
			try {
				let res = await api.jobs.getV4Banner(getBannerParams(e));
				if (res.code === 1000 && res.data[0].image ) {
          this.banner = res.data[0];
          console.log(this.banner)
				}

			} catch (e) {
				console.log(e)
			}
			},
      changeRouter(){
        let resRouter=this.$route.name;
        console.log(resRouter,1111)
        if(resRouter=='Jianlimoban'){
          this.getBanner(74);
        }else if(resRouter=='JobsList'){
           this.getBanner(75);
        }else if(resRouter=='blog'){
           this.getBanner(76);
        }else if(resRouter=='JobsList1'){
           this.getBanner(77);
        }

      },
      toLink() {
        if(!this.banner.link) return
        window.open(this.banner.link,"_blank")
      },
  }
}
</script>

<style lang="scss">
  .advertising_board {
    width: 100%;
    height:110px;
    // vertical-align:middle;
    display: flex;
    justify-content: center;
    // background: rgba(32, 35, 41, 0.8);
    position: fixed;
    cursor: pointer;
    bottom: 0;
    left: 0;
    z-index: 2000;
    &__inner {
      width: 1196px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      .close {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 1px solid rgba(255, 255, 255, .6);
        position: absolute;
        right: 60px;
        top: 30px;
        line-height: 18px;
        text-align: center;
        //opacity: .6;
      }
    }
    &__img {
      width: 204px;
      height: 149px;
      // margin-left: 60px;
      position: absolute;
      bottom: 0;
      left: 60px;
    }
    &__slogan {
      height: 100%;
      position: absolute;
      bottom: 0;
      left: calc(60px + 204px + 32px);
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      //padding-top: 20px;
      > span {
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;
        margin-bottom: 10px;
        letter-spacing: 2px;
      }
      strong {
        font-size: 22px;
        font-weight: 600;
        margin-bottom: 10px;
        .download_text {
          color: #fff;
        }
        .app_name {
          color: rgba(255, 102, 68, 1);
        }
      }
    }
    &__close_icon {
      color: #B7B8BA;
      cursor: pointer;
    }
    &__qr_code {
      width: 268px;
      height: calc(100% - 28px);
      position: absolute;
      right: 300px;
      bottom: 0;
      padding: 14px 0;
      display: flex;
      align-items: center;
      .qrcode_img {
        width: 106px;
        height: 106px;
        position: absolute;
        top: -10px;
        //border: 2px solid #AEAEB2;
        //margin-right: 18px;
      }
      .qr_code_text {
        height: 34px;
        width: 200px;
        line-height: 34px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        //opacity: .6;
        position: absolute;
        left: 122px;
        top: 37px;
        border: 1px solid rgba(255, 255, 255, .6);
        border-radius: 5px;
        //box-sizing: border-box;
        &:before {
          content: '';
          display: block;
          width: 7px;
          height: 7px;
          transform: rotate(45deg);
          background-color: #525358;
          position: absolute;
          left: -5px;
          top: 15px;
          border-left: 1px solid rgba(255, 255, 255, .6);
          border-bottom: 1px solid rgba(255, 255, 255, .6);
        }
      }
    }
  }
  .advertising_img{
    height: 110px;
    }
</style>
